import { render, staticRenderFns } from "./RegistrationBanner.vue?vue&type=template&id=7d892dd8&scoped=true"
import script from "./RegistrationBanner.vue?vue&type=script&lang=js"
export * from "./RegistrationBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d892dd8",
  null
  
)

export default component.exports